import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Router, browserHistory } from "react-router";
import configureStore from "../store/configureStore";
import routes from "./routes";
import Firebase, { FirebaseContext } from "./components/Firebase";
import { App2 } from "./components/app";

ReactDOM.render(
  <div>
    <Provider store={configureStore}>
      <FirebaseContext.Provider value={new Firebase()}>
        <Router history={browserHistory} routes={routes}>
          <App2 />
        </Router>
      </FirebaseContext.Provider>
    </Provider>
  </div>,
  document.getElementById("container")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.register();

// for bundling your styles
// import "./bundle.scss";
// console.log("starting...");
// ReactDOM.render(
//   <Provider store={configureStore}>
//     <Router history={browserHistory} routes={routes} />
//   </Provider>,
//   document.querySelector(".react-root")
// );

// import React from 'react';
// import ReactDOM from 'react-dom';
// import { Provider } from 'react-redux';
// import './index.css';

// import store from "./store";
// import App from "./components/App";



// WEBPACK FOOTER //
// ./src/app/index.jsx